"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _TinymceToolbar = _interopRequireDefault(require("./TinymceToolbar"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 0 8px;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledToolbar = (0, _styledComponents.default)(_TinymceToolbar.default).withConfig({
  displayName: "IframeToolbar__StyledToolbar",
  componentId: "sc-1lxyy45-0"
})(_templateObject(), _colors.BATTLESHIP);

var IframeToolbar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IframeToolbar, _Component);

  function IframeToolbar() {
    var _this;

    (0, _classCallCheck2.default)(this, IframeToolbar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IframeToolbar).call(this));
    _this.handleIframeClick = _this.handleIframeClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IframeToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.editor.on('click', this.handleIframeClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.editor.off('click', this.handleIframeClick);
    }
  }, {
    key: "handleIframeClick",
    value: function handleIframeClick() {
      this.props.editor.editorContainer.click();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          namespace = _this$props.namespace,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["namespace"]);
      var className = (0, _classNames.default)('mce-toolbar', namespace);
      return _react.default.createElement(StyledToolbar, (0, _extends2.default)({}, props, {
        className: className
      }));
    }
  }]);
  return IframeToolbar;
}(_react.Component);

exports.default = IframeToolbar;
IframeToolbar.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  namespace: _react.PropTypes.string
};
module.exports = exports.default;